webpackJsonp([1],{

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CustomActions__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(334);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



/* eslint-disable no-unused-vars */



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('custom-actions', __WEBPACK_IMPORTED_MODULE_3__components_CustomActions__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_081fe1d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(328);
function injectStyle (ssrContext) {
  __webpack_require__(237)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_081fe1d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 237:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_23911c86_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__ = __webpack_require__(295);
function injectStyle (ssrContext) {
  __webpack_require__(263)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23911c86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_23911c86_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 263:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFixedHeader)?_c('div',[_c('div',{staticClass:"vuetable-head-wrapper"},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableHeaderClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{key:fieldIndex,class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){return _vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{key:fieldIndex,class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){return _vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{key:fieldIndex,class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){return _vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{key:fieldIndex,class:['vuetable-th-sequence', field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){return _vm.orderBy(field, $event)}}})]]:_vm._e()]}),_vm._v(" "),(_vm.scrollVisible)?_c('th',{staticClass:"vuetable-gutter-col",style:({width: _vm.scrollBarWidth})}):_vm._e()],2)])])]),_vm._v(" "),_c('div',{staticClass:"vuetable-body-wrapper",style:({height: _vm.tableHeight})},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableBodyClass]},[_c('colgroup',[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[_c('col',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass],style:({width: field.width}),attrs:{"id":'_col_' + field.name}})]:_vm._e()]})],2),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,itemIndex){return [_c('tr',{key:itemIndex,class:_vm.onRowClass(item, itemIndex),attrs:{"item-index":itemIndex,"render":_vm.onRowChanged(item)},on:{"click":function($event){return _vm.onRowClicked(item, $event)},"dblclick":function($event){return _vm.onRowDoubleClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{key:fieldIndex,class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(itemIndex))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{key:fieldIndex,class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{key:fieldIndex,class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){return _vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{key:fieldIndex,class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":itemIndex,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{key:fieldIndex,class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{"rowData":item,"rowIndex":itemIndex,"rowField":field.sortField})],2):_vm._e()]:[_c('td',{key:fieldIndex,class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.renderNormalField(field, item))},on:{"click":function($event){return _vm.onCellClicked(item, field, $event)},"dblclick":function($event){return _vm.onCellDoubleClicked(item, field, $event)},"contextmenu":function($event){return _vm.onCellRightClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[_c('transition',{key:itemIndex,attrs:{"name":_vm.detailRowTransition}},[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){return _vm.onDetailRowClick(item, $event)}}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":itemIndex}})],1)]):_vm._e()])]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields},domProps:{"innerHTML":_vm._s(_vm.noDataTemplate)}})])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{key:i,staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?_c('td',{key:fieldIndex},[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])])]):_c('table',{class:['vuetable', _vm.css.tableClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{key:fieldIndex,class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){return _vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{key:fieldIndex,class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){return _vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{key:fieldIndex,class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){return _vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{key:fieldIndex,class:['vuetable-th-sequence', field.titleClass || '', _vm.sortClass(field)],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass || '', _vm.sortClass(field)],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass, _vm.sortClass(field),  {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){return _vm.orderBy(field, $event)}}})]]:_vm._e()]})],2)]),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,itemIndex){return [_c('tr',{key:itemIndex,class:_vm.onRowClass(item, itemIndex),attrs:{"item-index":itemIndex,"render":_vm.onRowChanged(item)},on:{"dblclick":function($event){return _vm.onRowDoubleClicked(item, $event)},"click":function($event){return _vm.onRowClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{key:fieldIndex,class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(itemIndex))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{key:fieldIndex,class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{key:fieldIndex,class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){return _vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{key:fieldIndex,class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":itemIndex,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{key:fieldIndex,class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{"rowData":item,"rowIndex":itemIndex,"rowField":field.sortField})],2):_vm._e()]:[(_vm.hasCallback(field))?_c('td',{key:fieldIndex,class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.callCallback(field, item))},on:{"click":function($event){return _vm.onCellClicked(item, field, $event)},"dblclick":function($event){return _vm.onCellDoubleClicked(item, field, $event)},"contextmenu":function($event){return _vm.onCellRightClicked(item, field, $event)}}}):_c('td',{key:fieldIndex,class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.getObjectValue(item, field.name, ''))},on:{"click":function($event){return _vm.onCellClicked(item, field, $event)},"dblclick":function($event){return _vm.onCellDoubleClicked(item, field, $event)},"contextmenu":function($event){return _vm.onCellRightClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[_c('transition',{key:itemIndex,attrs:{"name":_vm.detailRowTransition}},[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){return _vm.onDetailRowClick(item, $event)}}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":itemIndex}})],1)]):_vm._e()])]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields},domProps:{"innerHTML":_vm._s(_vm.noDataTemplate)}})])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{key:i,staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?_c('td',{key:fieldIndex},[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationInfo_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_204c9cd8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePaginationInfo_vue__ = __webpack_require__(298);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_204c9cd8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePaginationInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationInfoMixin_vue__ = __webpack_require__(79);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationInfoMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['vuetable-pagination-info', _vm.css.infoClass],domProps:{"innerHTML":_vm._s(_vm.paginationInfo)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VoerroTagsInput_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_769c2e48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VoerroTagsInput_vue__ = __webpack_require__(303);
function injectStyle (ssrContext) {
  __webpack_require__(302)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VoerroTagsInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_769c2e48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VoerroTagsInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 302:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-input-root"},[_c('div',{class:_vm.wrapperClass + ' tags-input'},[_vm._l((_vm.tagBadges),function(badge,index){return _c('span',{key:index,staticClass:"tags-input-badge tags-input-badge-pill tags-input-badge-selected-default"},[_c('span',{domProps:{"innerHTML":_vm._s(badge)}}),_vm._v(" "),_c('i',{staticClass:"tags-input-remove",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.removeTag(index)}}})])}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input),expression:"input"}],ref:"taginput",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.input)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.tagFromInput($event)},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==8){ return null; }return _vm.removeLastTag($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.nextSearchResult($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.prevSearchResult($event)},_vm.onKeyDown],"keyup":[_vm.searchTag,function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.ignoreSearchResults($event)}],"focus":_vm.onFocus,"blur":_vm.hideTypeahead,"value":_vm.tags,"input":function($event){if($event.target.composing){ return; }_vm.input=$event.target.value}}}),_vm._v(" "),(_vm.elementId)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hiddenInput),expression:"hiddenInput"}],attrs:{"type":"hidden","name":_vm.elementId,"id":_vm.elementId},domProps:{"value":(_vm.hiddenInput)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hiddenInput=$event.target.value}}}):_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchResults.length),expression:"searchResults.length"}]},[(_vm.typeaheadStyle === 'badges')?_c('p',{class:("typeahead-" + _vm.typeaheadStyle)},_vm._l((_vm.searchResults),function(tag,index){return _c('span',{key:index,staticClass:"tags-input-badge",class:{
                    'tags-input-typeahead-item-default': index != _vm.searchSelection,
                    'tags-input-typeahead-item-highlighted-default': index == _vm.searchSelection
                },domProps:{"textContent":_vm._s(tag.text)},on:{"mouseover":function($event){_vm.searchSelection = index},"mousedown":function($event){$event.preventDefault();return _vm.tagFromSearchOnClick(tag)}}})}),0):(_vm.typeaheadStyle === 'dropdown')?_c('ul',{class:("typeahead-" + _vm.typeaheadStyle)},_vm._l((_vm.searchResults),function(tag,index){return _c('li',{key:index,class:{
                'tags-input-typeahead-item-default': index != _vm.searchSelection,
                'tags-input-typeahead-item-highlighted-default': index == _vm.searchSelection
            },domProps:{"textContent":_vm._s(tag.text)},on:{"mouseover":function($event){_vm.searchSelection = index},"mousedown":function($event){$event.preventDefault();return _vm.tagFromSearchOnClick(tag)}}})}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GithubToken_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01b7bb37_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GithubToken_vue__ = __webpack_require__(305);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GithubToken_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01b7bb37_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GithubToken_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.githubTokenExist)?_c('div',{staticClass:"container"},[_c('form',[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"token"}},[_vm._v("GitHub Token: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.githubToken),expression:"githubToken"}],staticClass:"form-control",attrs:{"type":"password","id":"token","placeholder":"GitHub Token"},domProps:{"value":(_vm.githubToken)},on:{"input":function($event){if($event.target.composing){ return; }_vm.githubToken=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-2",attrs:{"type":"submit"},on:{"click":_vm.setGithubToken}},[_vm._v("Add")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a971d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__ = __webpack_require__(307);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a971d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group pull-right"},[_c('label',{attrs:{"for":"filterText"}},[_vm._v("Search: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],staticClass:"form-control",attrs:{"type":"text","id":"filterText","placeholder":"Title, Issue #, Repository"},domProps:{"value":(_vm.filterText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterTime_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8f45cf8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterTime_vue__ = __webpack_require__(315);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8f45cf8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-4"},[_c('label',{attrs:{"for":"filter-time"}},[_vm._v("Filter :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterTime),expression:"filterTime"}],staticClass:"form-control",attrs:{"id":"filter-time"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterTime=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.handleTimeChange]}},[_c('option',{attrs:{"value":""}},[_vm._v("All")]),_vm._v(" "),_c('option',{attrs:{"value":"7days"}},[_vm._v("Last 7 days")]),_vm._v(" "),_c('option',{attrs:{"value":"15days"}},[_vm._v("Last 15 days")]),_vm._v(" "),_c('option',{attrs:{"value":"30days"}},[_vm._v("Last 30 days")]),_vm._v(" "),_c('option',{attrs:{"value":"recent5"}},[_vm._v("Most Recent 5")]),_vm._v(" "),_c('option',{attrs:{"value":"recent10"}},[_vm._v("Most Recent 10")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterOrg_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d2a6e9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterOrg_vue__ = __webpack_require__(318);
function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterOrg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d2a6e9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterOrg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 317:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group pull-left"},[_c('label',{attrs:{"for":"filer-org"}},[_vm._v("Organization: ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterOrg),expression:"filterOrg"}],staticClass:"form-control",attrs:{"id":"filer-org"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterOrg=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.handleOrgChange]}},[_c('option',{attrs:{"value":""}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.orgs),function(org){return _c('option',{key:org},[_vm._v(_vm._s(org))])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterType_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32aa2047_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterType_vue__ = __webpack_require__(321);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32aa2047_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group pull-left"},[_c('label',{attrs:{"for":"filer-org"}},[_vm._v("Type: ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterType),expression:"filterType"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.handleTypeChange]}},[_c('option',{attrs:{"value":""}},[_vm._v("All")]),_vm._v(" "),_c('option',{attrs:{"value":"pr"}},[_vm._v("PR")]),_vm._v(" "),_c('option',{attrs:{"value":"issue"}},[_vm._v("Issue")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuetablePaginationBootstrap_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_737a7d64_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuetablePaginationBootstrap_vue__ = __webpack_require__(324);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuetablePaginationBootstrap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_737a7d64_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuetablePaginationBootstrap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination"},[_c('li',{class:{'disabled': _vm.isOnFirstPage}},[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.loadPage('prev')}}},[_c('span',[_vm._v("«")])])]),_vm._v(" "),(_vm.notEnoughPages)?_vm._l((_vm.totalPage),function(n){return _c('li',{key:n,class:{'active': _vm.isCurrentPage(n)}},[_c('a',{domProps:{"innerHTML":_vm._s(n)},on:{"click":function($event){$event.preventDefault();return _vm.loadPage(n)}}})])}):_vm._l((_vm.windowSize),function(n){return _c('li',{key:n,class:{'active': _vm.isCurrentPage(_vm.windowStart+n-1)}},[_c('a',{domProps:{"innerHTML":_vm._s(_vm.windowStart+n-1)},on:{"click":function($event){$event.preventDefault();return _vm.loadPage(_vm.windowStart+n-1)}}})])}),_vm._v(" "),_c('li',{class:{'disabled': _vm.isOnLastPage}},[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.loadPage('next')}}},[_c('span',[_vm._v("»")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('br'),_vm._v(" "),_c('github-token'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('tags-input',{attrs:{"element-id":"tags","placeholder":"      Add Organization","typeahead":false},model:{value:(_vm.orgs),callback:function ($$v) {_vm.orgs=$$v},expression:"orgs"}})],1),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container",staticStyle:{"margin-bottom":"10px"}},[_c('form',[_c('div',{staticClass:"form-inline"},[_c('filter-org'),_vm._v(" "),_c('filter-time'),_vm._v(" "),_c('filter-type'),_vm._v(" "),_c('filter-bar')],1)])]),_vm._v(" "),(_vm.getCheckboxSelectedIssues.length)?_c('div',[_c('form',[_c('div',{staticClass:"btn-group pull-left"},[_c('p',[_vm._v("Actions: \n          "),_c('span',{staticClass:"btn btn-default",attrs:{"type":"button","title":"Mark as read"},on:{"click":_vm.markTheIssuesAsRead}},[_c('i',{staticClass:"fa fa-envelope-open-o",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('br')])])]):_vm._e(),_vm._v(" "),_c('Vuetable',{ref:"vuetable",attrs:{"api-mode":false,"data":_vm.getIssues,"data-path":"data","fields":_vm.fields,"pagination-path":"","track-by":"title","row-class":_vm.onRowClass,"multi-sort":true},on:{"vuetable:cell-clicked":_vm.onCellClicked,"vuetable:pagination-data":_vm.onPaginationData,"vuetable:checkbox-toggled":_vm.onToggleCheckbox,"vuetable:checkbox-toggled-all":_vm.onToggleCheckboxAll},scopedSlots:_vm._u([{key:"index",fn:function(props){return [_vm._v("\n      "+_vm._s(props.rowIndex + 1)+"\n    ")]}},{key:"titlelink",fn:function(props){return [_c('div',[_c('a',{attrs:{"href":props.rowData.htmlUrl,"target":"_blank"},on:{"click":function($event){return _vm.handleClickOnTitle(props)}}},[(props.rowData.isPR)?_c('span',{staticClass:"badge badge-light"},[_vm._v("PR")]):_vm._e(),_vm._v(" "+_vm._s(props.rowData.title)+"\n          "),_vm._l((props.rowData.labels),function(label,index){return [_c('span',{key:index,staticClass:"badge",style:(_vm.getLabelStyle(label))},[_vm._v(_vm._s(label.name))]),_vm._v("  \n          ")]})],2)])]}},{key:"issueNumber",fn:function(props){return [_c('div',[_c('a',{attrs:{"href":props.rowData.htmlUrl,"target":"_blank"},on:{"click":function($event){return _vm.handleClickOnTitle(props)}}},[_vm._v(_vm._s(props.rowData.orgName)+"/"+_vm._s(props.rowData.repoName)+"#"+_vm._s(props.rowData.number))])])]}}])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-1 pull-right github"},[_c('a',{staticClass:"github-button",attrs:{"href":"https://github.com/appscodelabs/github-issue-viewer","target":"_blank","title":"View on GitHub"}},[_vm._v(" GitHub")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailRow_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1586e07a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailRow_vue__ = __webpack_require__(327);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1586e07a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.onClick}},[_c('div',{staticClass:"inline field"},[_c('label',[_vm._v("Name: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rowData.name))])]),_vm._v(" "),_c('div',{staticClass:"inline field"},[_c('label',[_vm._v("Email: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rowData.email))])]),_vm._v(" "),_c('div',{staticClass:"inline field"},[_c('label',[_vm._v("Nickname: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rowData.nickname))])]),_vm._v(" "),_c('div',{staticClass:"inline field"},[_c('label',[_vm._v("Birthdate: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rowData.birthdate))])]),_vm._v(" "),_c('div',{staticClass:"inline field"},[_c('label',[_vm._v("Gender: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rowData.gender))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MyVuetable__ = __webpack_require__(48);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition;
  },

  routes: [{
    path: '/',
    name: 'MyVuetable',
    component: __WEBPACK_IMPORTED_MODULE_2__components_MyVuetable__["a" /* default */]
  }, {
    path: '/search/:a?',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_2__components_MyVuetable__["a" /* default */]
  }]
}));

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomActions_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c017102_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomActions_vue__ = __webpack_require__(333);
function injectStyle (ssrContext) {
  __webpack_require__(332)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c017102_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 332:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"ui basic button",on:{"click":function($event){return _vm.itemAction('view-item', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"zoom icon"})]),_vm._v(" "),_c('button',{staticClass:"ui basic button",on:{"click":function($event){return _vm.itemAction('edit-item', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"edit icon"})]),_vm._v(" "),_c('button',{staticClass:"ui basic button",on:{"click":function($event){return _vm.itemAction('delete-item', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"delete icon"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(343);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__webpack_require__(364), {
  moment: __WEBPACK_IMPORTED_MODULE_2_moment___default.a
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    orgs: localStorage.getItem('orgs'),
    githubToken: localStorage.getItem('githubToken'),
    repos: [],
    issues: [],
    checkboxSelectedIssues: [],
    checkboxSelectedIssueToIndexMap: {},
    issueUrlUnique: {},
    issueRecent5UrlUnique: {},
    issueRecent10UrlUnique: {},
    filteredIssues: [],
    recent5Issues: [],
    recent10Issues: [],
    newIssue: '',
    filterText: '',
    filterOrg: '',
    filterTime: '',
    filterType: ''
  },

  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */],

  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],

  actions: __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* default */]
}));

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 92,
	"./af.js": 92,
	"./ar": 93,
	"./ar-dz": 94,
	"./ar-dz.js": 94,
	"./ar-kw": 95,
	"./ar-kw.js": 95,
	"./ar-ly": 96,
	"./ar-ly.js": 96,
	"./ar-ma": 97,
	"./ar-ma.js": 97,
	"./ar-sa": 98,
	"./ar-sa.js": 98,
	"./ar-tn": 99,
	"./ar-tn.js": 99,
	"./ar.js": 93,
	"./az": 100,
	"./az.js": 100,
	"./be": 101,
	"./be.js": 101,
	"./bg": 102,
	"./bg.js": 102,
	"./bm": 103,
	"./bm.js": 103,
	"./bn": 104,
	"./bn-bd": 105,
	"./bn-bd.js": 105,
	"./bn.js": 104,
	"./bo": 106,
	"./bo.js": 106,
	"./br": 107,
	"./br.js": 107,
	"./bs": 108,
	"./bs.js": 108,
	"./ca": 109,
	"./ca.js": 109,
	"./cs": 110,
	"./cs.js": 110,
	"./cv": 111,
	"./cv.js": 111,
	"./cy": 112,
	"./cy.js": 112,
	"./da": 113,
	"./da.js": 113,
	"./de": 114,
	"./de-at": 115,
	"./de-at.js": 115,
	"./de-ch": 116,
	"./de-ch.js": 116,
	"./de.js": 114,
	"./dv": 117,
	"./dv.js": 117,
	"./el": 118,
	"./el.js": 118,
	"./en-au": 119,
	"./en-au.js": 119,
	"./en-ca": 120,
	"./en-ca.js": 120,
	"./en-gb": 121,
	"./en-gb.js": 121,
	"./en-ie": 122,
	"./en-ie.js": 122,
	"./en-il": 123,
	"./en-il.js": 123,
	"./en-in": 124,
	"./en-in.js": 124,
	"./en-nz": 125,
	"./en-nz.js": 125,
	"./en-sg": 126,
	"./en-sg.js": 126,
	"./eo": 127,
	"./eo.js": 127,
	"./es": 128,
	"./es-do": 129,
	"./es-do.js": 129,
	"./es-mx": 130,
	"./es-mx.js": 130,
	"./es-us": 131,
	"./es-us.js": 131,
	"./es.js": 128,
	"./et": 132,
	"./et.js": 132,
	"./eu": 133,
	"./eu.js": 133,
	"./fa": 134,
	"./fa.js": 134,
	"./fi": 135,
	"./fi.js": 135,
	"./fil": 136,
	"./fil.js": 136,
	"./fo": 137,
	"./fo.js": 137,
	"./fr": 138,
	"./fr-ca": 139,
	"./fr-ca.js": 139,
	"./fr-ch": 140,
	"./fr-ch.js": 140,
	"./fr.js": 138,
	"./fy": 141,
	"./fy.js": 141,
	"./ga": 142,
	"./ga.js": 142,
	"./gd": 143,
	"./gd.js": 143,
	"./gl": 144,
	"./gl.js": 144,
	"./gom-deva": 145,
	"./gom-deva.js": 145,
	"./gom-latn": 146,
	"./gom-latn.js": 146,
	"./gu": 147,
	"./gu.js": 147,
	"./he": 148,
	"./he.js": 148,
	"./hi": 149,
	"./hi.js": 149,
	"./hr": 150,
	"./hr.js": 150,
	"./hu": 151,
	"./hu.js": 151,
	"./hy-am": 152,
	"./hy-am.js": 152,
	"./id": 153,
	"./id.js": 153,
	"./is": 154,
	"./is.js": 154,
	"./it": 155,
	"./it-ch": 156,
	"./it-ch.js": 156,
	"./it.js": 155,
	"./ja": 157,
	"./ja.js": 157,
	"./jv": 158,
	"./jv.js": 158,
	"./ka": 159,
	"./ka.js": 159,
	"./kk": 160,
	"./kk.js": 160,
	"./km": 161,
	"./km.js": 161,
	"./kn": 162,
	"./kn.js": 162,
	"./ko": 163,
	"./ko.js": 163,
	"./ku": 164,
	"./ku.js": 164,
	"./ky": 165,
	"./ky.js": 165,
	"./lb": 166,
	"./lb.js": 166,
	"./lo": 167,
	"./lo.js": 167,
	"./lt": 168,
	"./lt.js": 168,
	"./lv": 169,
	"./lv.js": 169,
	"./me": 170,
	"./me.js": 170,
	"./mi": 171,
	"./mi.js": 171,
	"./mk": 172,
	"./mk.js": 172,
	"./ml": 173,
	"./ml.js": 173,
	"./mn": 174,
	"./mn.js": 174,
	"./mr": 175,
	"./mr.js": 175,
	"./ms": 176,
	"./ms-my": 177,
	"./ms-my.js": 177,
	"./ms.js": 176,
	"./mt": 178,
	"./mt.js": 178,
	"./my": 179,
	"./my.js": 179,
	"./nb": 180,
	"./nb.js": 180,
	"./ne": 181,
	"./ne.js": 181,
	"./nl": 182,
	"./nl-be": 183,
	"./nl-be.js": 183,
	"./nl.js": 182,
	"./nn": 184,
	"./nn.js": 184,
	"./oc-lnc": 185,
	"./oc-lnc.js": 185,
	"./pa-in": 186,
	"./pa-in.js": 186,
	"./pl": 187,
	"./pl.js": 187,
	"./pt": 188,
	"./pt-br": 189,
	"./pt-br.js": 189,
	"./pt.js": 188,
	"./ro": 190,
	"./ro.js": 190,
	"./ru": 191,
	"./ru.js": 191,
	"./sd": 192,
	"./sd.js": 192,
	"./se": 193,
	"./se.js": 193,
	"./si": 194,
	"./si.js": 194,
	"./sk": 195,
	"./sk.js": 195,
	"./sl": 196,
	"./sl.js": 196,
	"./sq": 197,
	"./sq.js": 197,
	"./sr": 198,
	"./sr-cyrl": 199,
	"./sr-cyrl.js": 199,
	"./sr.js": 198,
	"./ss": 200,
	"./ss.js": 200,
	"./sv": 201,
	"./sv.js": 201,
	"./sw": 202,
	"./sw.js": 202,
	"./ta": 203,
	"./ta.js": 203,
	"./te": 204,
	"./te.js": 204,
	"./tet": 205,
	"./tet.js": 205,
	"./tg": 206,
	"./tg.js": 206,
	"./th": 207,
	"./th.js": 207,
	"./tk": 208,
	"./tk.js": 208,
	"./tl-ph": 209,
	"./tl-ph.js": 209,
	"./tlh": 210,
	"./tlh.js": 210,
	"./tr": 211,
	"./tr.js": 211,
	"./tzl": 212,
	"./tzl.js": 212,
	"./tzm": 213,
	"./tzm-latn": 214,
	"./tzm-latn.js": 214,
	"./tzm.js": 213,
	"./ug-cn": 215,
	"./ug-cn.js": 215,
	"./uk": 216,
	"./uk.js": 216,
	"./ur": 217,
	"./ur.js": 217,
	"./uz": 218,
	"./uz-latn": 219,
	"./uz-latn.js": 219,
	"./uz.js": 218,
	"./vi": 220,
	"./vi.js": 220,
	"./x-pseudo": 221,
	"./x-pseudo.js": 221,
	"./yo": 222,
	"./yo.js": 222,
	"./zh-cn": 223,
	"./zh-cn.js": 223,
	"./zh-hk": 224,
	"./zh-hk.js": 224,
	"./zh-mo": 225,
	"./zh-mo.js": 225,
	"./zh-tw": 226,
	"./zh-tw.js": 226
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 336;

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var getIssues = function getIssues(state) {
  return state.filteredIssues.sort(function (a, b) {
    return b.updatedAt - a.updatedAt;
  });
};
var getOrgs = function getOrgs(state) {
  return state.orgs;
};
var getCheckboxSelectedIssues = function getCheckboxSelectedIssues(state) {
  return state.checkboxSelectedIssues;
};
var getFilterText = function getFilterText(state) {
  return state.filterText;
};
var getFilterOrg = function getFilterOrg(state) {
  return state.filterOrg;
};
var getFilterTime = function getFilterTime(state) {
  return state.filterTime;
};
var getFilterType = function getFilterType(state) {
  return state.filterType;
};
var getGithubToken = function getGithubToken(state) {
  return state.githubToken;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getIssues: getIssues,
  getOrgs: getOrgs,
  getCheckboxSelectedIssues: getCheckboxSelectedIssues,
  getFilterText: getFilterText,
  getFilterOrg: getFilterOrg,
  getFilterTime: getFilterTime,
  getFilterType: getFilterType,
  getGithubToken: getGithubToken
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



/* eslint-disable no-param-reassign */
var SET_ORGS = function SET_ORGS(state, orgs) {
  state.orgs = orgs;
};
var SET_GITHUB_TOKEN = function SET_GITHUB_TOKEN(state, githubToken) {
  state.githubToken = githubToken;
};
var ADD_REPOS = function ADD_REPOS(state, repos) {
  state.repos = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.repos), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(repos));
};
var ADD_ISSUE = function ADD_ISSUE(state, newIssue) {
  state.issues.push(newIssue);
  state.filteredIssues.push(newIssue);
};
var ADD_RECENT_5_ISSUE = function ADD_RECENT_5_ISSUE(state, newIssue) {
  state.recent5Issues.push(newIssue);
};
var ADD_RECENT_10_ISSUE = function ADD_RECENT_10_ISSUE(state, newIssue) {
  state.recent10Issues.push(newIssue);
};
var UPDATE_ISSUE_FOR_CHECKBOX_TOGGLE = function UPDATE_ISSUE_FOR_CHECKBOX_TOGGLE(state, checkboxObj) {
  if (checkboxObj.isSelected) {
    state.checkboxSelectedIssues.push(checkboxObj);

    state.checkboxSelectedIssueToIndexMap[checkboxObj.htmlUrl] = state.checkboxSelectedIssues.length - 1;
  } else {
    state.checkboxSelectedIssues.splice(state.checkboxSelectedIssueToIndexMap[checkboxObj.htmlUrl], 1);
  }
};
var RESET_CHECKBOX_SELECTED_ISSUES = function RESET_CHECKBOX_SELECTED_ISSUES(state) {
  state.checkboxSelectedIssues = [];
  state.checkboxSelectedIssueToIndexMap = {};
};
var SET_FILTER_TEXT = function SET_FILTER_TEXT(state, filterText) {
  state.filterText = filterText;
};
var SET_FILTER_ORG = function SET_FILTER_ORG(state, filterOrg) {
  state.filterOrg = filterOrg;
};
var SET_FILTER_TIME = function SET_FILTER_TIME(state, filterTime) {
  state.filterTime = filterTime;
};
var SET_FILTER_TYPE = function SET_FILTER_TYPE(state, filterType) {
  state.filterType = filterType;
};
var UPDATE_FILTER_ISSUES = function UPDATE_FILTER_ISSUES(state) {
  var filteredIssues = ''; // [...state.issues]
  if (state.filterTime) {
    var filterTime = state.filterTime;
    if (filterTime === 'recent5') {
      filteredIssues = state.recent5Issues;
    } else if (filterTime === 'recent10') {
      filteredIssues = state.recent10Issues;
    } else {
      filteredIssues = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.issues));
    }
    switch (filterTime) {
      case '7days':
        {
          var time7DaysAgo = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(7, 'd');
          filteredIssues = filteredIssues.filter(function (issue) {
            var b = issue.timestamp - time7DaysAgo.valueOf();
            return b >= 0;
          });
          break;
        }
      case '15days':
        {
          var time15DaysAgo = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(15, 'd');
          filteredIssues = filteredIssues.filter(function (issue) {
            return issue.timestamp >= time15DaysAgo.valueOf();
          });
          break;
        }
      case '30days':
        {
          var time30DaysAgo = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(30, 'd');
          filteredIssues = filteredIssues.filter(function (issue) {
            var a = issue.timestamp - time30DaysAgo.valueOf();
            return a >= 0;
          });
          break;
        }
      default:
        {
          break;
        }
    }
  } else {
    filteredIssues = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.issues));
  }
  if (state.filterOrg) {
    var regexp = new RegExp(state.filterOrg, 'i');
    filteredIssues = filteredIssues.filter(function (issue) {
      var res = issue.orgName.search(regexp) >= 0;
      return res;
    });
  }
  if (state.filterText) {
    var _regexp = new RegExp(state.filterText, 'i');
    filteredIssues = filteredIssues.filter(function (issue) {
      return issue.title.search(_regexp) >= 0 || issue.number.search(_regexp) >= 0 || issue.repoName.search(_regexp) >= 0;
    });
  }

  if (state.filterType) {
    var type = state.filterType;
    if (type === 'pr') {
      filteredIssues = filteredIssues.filter(function (issue) {
        return issue.isPR;
      });
    } else {
      filteredIssues = filteredIssues.filter(function (issue) {
        return !issue.isPR;
      });
    }
  }

  state.filteredIssues = filteredIssues;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_ORGS: SET_ORGS,
  SET_GITHUB_TOKEN: SET_GITHUB_TOKEN,
  ADD_REPOS: ADD_REPOS,
  ADD_ISSUE: ADD_ISSUE,
  ADD_RECENT_5_ISSUE: ADD_RECENT_5_ISSUE,
  ADD_RECENT_10_ISSUE: ADD_RECENT_10_ISSUE,
  UPDATE_ISSUE_FOR_CHECKBOX_TOGGLE: UPDATE_ISSUE_FOR_CHECKBOX_TOGGLE,
  RESET_CHECKBOX_SELECTED_ISSUES: RESET_CHECKBOX_SELECTED_ISSUES,
  SET_FILTER_TEXT: SET_FILTER_TEXT,
  SET_FILTER_ORG: SET_FILTER_ORG,
  SET_FILTER_TIME: SET_FILTER_TIME,
  SET_FILTER_TYPE: SET_FILTER_TYPE,
  UPDATE_FILTER_ISSUES: UPDATE_FILTER_ISSUES
});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);






var _this = this;




var setOrgs = function setOrgs(_ref, orgs) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  localStorage.setItem('orgs', orgs);
  commit('SET_ORGS', orgs);
  dispatch('getRepoIssues');
};
var setGithubToken = function setGithubToken(_ref2, githubToken) {
  var commit = _ref2.commit;

  localStorage.setItem('githubToken', githubToken);
  commit('SET_GITHUB_TOKEN', githubToken);
};
var addIssue = function addIssue(_ref3, newIssue) {
  var commit = _ref3.commit;

  commit('ADD_ISSUE', newIssue);
  commit('UPDATE_FILTER_ISSUES');
};
var addRecent5Issues = function addRecent5Issues(_ref4, newIssue) {
  var commit = _ref4.commit;

  commit('ADD_RECENT_5_ISSUE', newIssue);
};
var addRecent10Issues = function addRecent10Issues(_ref5, newIssue) {
  var commit = _ref5.commit;

  commit('ADD_RECENT_10_ISSUE', newIssue);
};

var getDayDiff = function getDayDiff(options) {
  var timePrev = parseInt(__WEBPACK_IMPORTED_MODULE_6_moment___default()(options.createdAt).valueOf() / 1000, 10);
  var timeNow = Math.floor(new Date().getTime() / 1000); // utc time (s)
  var timeRes = timeNow - timePrev;
  var unit = '';
  if (timeRes < 60) {
    unit = ' second';
  } else if (timeRes < 3600) {
    timeRes = parseInt(timeRes / 60, 10);
    unit = ' minute';
  } else if (timeRes < 86400) {
    timeRes = parseInt(timeRes / 3600, 10);
    unit = ' hour';
  } else {
    timeRes = parseInt(timeRes / 86400, 10);
    unit = ' day';
  }
  if (timeRes > 1) {
    unit = unit + 's';
  }
  return '' + timeRes + unit + ' ago';
};

var getIssues = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref7, _ref8) {
    var dispatch = _ref7.dispatch,
        state = _ref7.state;
    var orgName = _ref8.orgName,
        repoName = _ref8.repoName;

    var issues, dispatchAddIssue, addMostRecent5Issues, addMostRecent10Issues, issuesLastUpdated, needToUpdate, idb, apiUrl, apiHeaders, resp, open, db, _idb, _open, _db;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            issues = [];

            // update state.issues[] items

            dispatchAddIssue = function dispatchAddIssue(issu, issuLen, whichArray) {
              var issueLen = issuLen || issu.length;
              for (var i = 0; i < issueLen; i += 1) {
                var issue = issu[i];

                var newIssue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({
                  orgName: orgName,
                  repoName: repoName
                }, {
                  id: issue.title,
                  title: issue.title,
                  labels: issue.labels,
                  htmlUrl: issue.html_url,
                  number: issue.number.toString(),
                  createdAt: getDayDiff({ createdAt: issue.created_at }),
                  timestamp: __WEBPACK_IMPORTED_MODULE_6_moment___default()(issue.created_at).valueOf(),
                  updatedAt: __WEBPACK_IMPORTED_MODULE_6_moment___default()(issue.updated_at).valueOf(),
                  isPR: issue.html_url.search('/pull/') >= 0
                });

                /* eslint-disable no-param-reassign */
                if (!whichArray && !state.issueUrlUnique[issue.html_url]) {
                  state.issueUrlUnique[issue.html_url] = true;
                  dispatch('addIssue', newIssue);
                } else if (whichArray === 'recent5Issues' && !state.issueRecent5UrlUnique[issue.html_url]) {
                  state.issueRecent5UrlUnique[issue.html_url] = true;
                  dispatch('addRecent5Issues', newIssue);
                } else if (whichArray === 'recent10Issues' && !state.issueRecent10UrlUnique[issue.html_url]) {
                  state.issueRecent10UrlUnique[issue.html_url] = true;
                  dispatch('addRecent10Issues', newIssue);
                }
              }
            };

            addMostRecent5Issues = function addMostRecent5Issues(issu) {
              var issueLen = issu.length;
              issueLen = issueLen < 5 ? issueLen : 4;
              dispatchAddIssue(issu, issueLen, 'recent5Issues');
            };

            addMostRecent10Issues = function addMostRecent10Issues(issu) {
              var issueLen = issu.length;
              issueLen = issueLen < 10 ? issueLen : 9;
              dispatchAddIssue(issu, issueLen, 'recent10Issues');
            };

            issuesLastUpdated = localStorage.getItem(orgName + '-' + repoName + '-issues');
            needToUpdate = !issuesLastUpdated || issuesLastUpdated - __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(10, 'minutes') < 0;

            if (!needToUpdate) {
              _context.next = 20;
              break;
            }

            idb = global.indexedDB || global.mozIndexedDB || global.webkitIndexedDB || global.msIndexedDB;

            // const apiUrl = 'https://api.github.com/repos/sajibcse68/delete-it/issues';

            apiUrl = 'https://api.github.com/repos/' + orgName + '/' + repoName + '/issues';
            apiHeaders = state.githubToken ? {
              headers: {
                Authorization: 'token ' + state.githubToken
              }
            } : {};
            _context.next = 12;
            return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(apiUrl, apiHeaders);

          case 12:
            resp = _context.sent;

            /*
            const resp = {
              data: [
                {
                  title: 'abc',
                  html_url: 'a/b/c',
                  number: 1,
                  created_at: moment().valueOf(),
                  timestamp: moment().valueOf(),
                },
                {
                  title: 'def',
                  html_url: 'd/e/f',
                  number: 2,
                  created_at: moment().subtract(1, 'm').valueOf,
                  timestamp: moment().subtract(1, 'm').valueOf,
                },
              ],
            };
            */
            issues = resp.data;
            open = idb.open('issues-db', 1);
            db = '';

            open.onupgradeneeded = function a() {
              db = open.result;
              db.createObjectStore('issues', { autoIncrement: true });
            };

            open.onsuccess = function b() {
              db = open.result;
              var tx = db.transaction('issues', 'readwrite');
              var store = tx.objectStore('issues');

              store.put(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(issues), orgName + '/' + repoName);
              issuesLastUpdated = localStorage.setItem(orgName + '-' + repoName + '-issues', __WEBPACK_IMPORTED_MODULE_6_moment___default()().valueOf());
              dispatchAddIssue(issues);
              addMostRecent5Issues(issues);
              addMostRecent10Issues(issues);

              tx.oncomplete = function c() {
                db.close();
              };
            };
            _context.next = 24;
            break;

          case 20:
            _idb = global.indexedDB || global.mozIndexedDB || global.webkitIndexedDB || global.msIndexedDB;
            _open = _idb.open('issues-db', 1);
            _db = '';


            _open.onsuccess = function b() {
              _db = _open.result;
              var tx = _db.transaction('issues', 'readonly');
              var store = tx.objectStore('issues');

              var getStoreIssues = store.get(orgName + '/' + repoName);
              getStoreIssues.onsuccess = function getStoreIssuesSuccess() {
                var allIssues = JSON.parse(getStoreIssues.result);
                dispatchAddIssue(allIssues);
                addMostRecent5Issues(allIssues);
                addMostRecent10Issues(allIssues);
              };

              tx.oncomplete = function c() {
                _db.close();
              };
            };

          case 24:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function getIssues(_x, _x2) {
    return _ref6.apply(this, arguments);
  };
}();
var getRepos = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref10, orgName) {
    var commit = _ref10.commit,
        state = _ref10.state,
        dispatch = _ref10.dispatch;
    var repoNames, repoNamesLastUpdated, needToUpdate, apiUrl, apiHeaders, resp, reposLen, i, repoName;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            repoNames = localStorage.getItem(orgName);
            repoNamesLastUpdated = localStorage.getItem(orgName + 'RepoNamesLastUpdated');
            needToUpdate = !repoNamesLastUpdated || repoNamesLastUpdated - __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(10, 'minutes').valueOf() < 0;

            if (!needToUpdate) {
              _context2.next = 14;
              break;
            }

            apiUrl = 'https://api.github.com/orgs/' + orgName + '/repos';
            apiHeaders = state.githubToken ? {
              headers: {
                Authorization: 'token ' + state.githubToken
              }
            } : {};
            _context2.next = 8;
            return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(apiUrl, apiHeaders);

          case 8:
            resp = _context2.sent;

            repoNames = resp.data.map(function (repo) {
              return repo.name;
            });
            localStorage.setItem(orgName, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(repoNames));
            localStorage.setItem(orgName + 'RepoNamesLastUpdated', __WEBPACK_IMPORTED_MODULE_6_moment___default()().valueOf());
            _context2.next = 15;
            break;

          case 14:
            repoNames = JSON.parse(repoNames);

          case 15:
            commit('ADD_REPOS', repoNames);
            reposLen = repoNames.length;


            for (i = 0; i < reposLen; i += 1) {
              repoName = repoNames[i];

              dispatch('getIssues', { orgName: orgName, repoName: repoName });
            }

          case 18:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function getRepos(_x3, _x4) {
    return _ref9.apply(this, arguments);
  };
}();
var updateIssueForCheckboxToggle = function updateIssueForCheckboxToggle(_ref11, checkboxObj) {
  var commit = _ref11.commit;

  commit('UPDATE_ISSUE_FOR_CHECKBOX_TOGGLE', checkboxObj);
};
var resetCheckboxSelectedIssues = function resetCheckboxSelectedIssues(_ref12) {
  var commit = _ref12.commit;

  commit('RESET_CHECKBOX_SELECTED_ISSUES');
};
var updateAllIssuesForCheckboxToggle = function updateAllIssuesForCheckboxToggle(_ref13, checkboxObj) {
  var state = _ref13.state,
      commit = _ref13.commit;

  if (checkboxObj.isSelected) {
    var filteredIssues = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.filteredIssues));
    var len = filteredIssues.length;
    for (var i = 0; i < len; i += 1) {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(filteredIssues[i], { isSelected: true });
      commit('UPDATE_ISSUE_FOR_CHECKBOX_TOGGLE', filteredIssues[i]);
    }
  } else {
    commit('RESET_CHECKBOX_SELECTED_ISSUES');
  }
};
var setFilterText = function setFilterText(_ref14, filterText) {
  var commit = _ref14.commit;

  commit('SET_FILTER_TEXT', filterText);
  commit('UPDATE_FILTER_ISSUES');
};
var setFilterOrg = function setFilterOrg(_ref15, filterOrg) {
  var commit = _ref15.commit;

  commit('SET_FILTER_ORG', filterOrg);
  commit('UPDATE_FILTER_ISSUES');
};
var setFilterTime = function setFilterTime(_ref16, filterTime) {
  var commit = _ref16.commit;

  commit('SET_FILTER_TIME', filterTime);
  commit('UPDATE_FILTER_ISSUES');
};
var setFilterType = function setFilterType(_ref17, filterType) {
  var commit = _ref17.commit;

  commit('SET_FILTER_TYPE', filterType);
  commit('UPDATE_FILTER_ISSUES');
};
var getRepoIssues = function getRepoIssues(_ref18) {
  var state = _ref18.state,
      dispatch = _ref18.dispatch;

  var orgs = state.orgs && state.orgs.split(',');

  // cleanup previous issues
  state.issues = [];
  state.filteredIssues = [];
  state.issueUrlUnique = {};

  var orgsLen = orgs.length;
  for (var i = 0; i < orgsLen; i += 1) {
    var orgName = orgs[i];
    dispatch('getRepos', orgName);
  }
};

/* eslint-disable */
var cleanupIssuesClickedTimestamp = function cleanupIssuesClickedTimestamp(_ref19) {
  var state = _ref19.state;

  var allIssuesHtmlUrl = {};
  var issues = state.issues;
  var len = issues.length;
  for (var i = 0; i < len; i += 1) {
    allIssuesHtmlUrl[issues[i].htmlUrl] = true;
  }

  var idb = global.indexedDB || global.mozIndexedDB || global.webkitIndexedDB || global.msIndexedDB;
  var open = idb.open('issues-clicked-timestamp', 2);
  var db = '';
  open.onupgradeneeded = function a() {
    db = open.result;
    db.createObjectStore('issue', { autoIncrement: true });
  };

  open.onsuccess = function openSuccess() {
    db = open.result;

    var tx = db.transaction('issue', 'readwrite');
    var store = tx.objectStore('issue');
    var allIssuesTimestamps = store.getAllKeys();

    allIssuesTimestamps.onsuccess = function allIssuesTimestampsSuccess() {
      var allTimestamps = allIssuesTimestamps.result;
      var len = allTimestamps.length;
      for (var ii = 0; ii < len; ii += 1) {
        if (!allIssuesHtmlUrl[allTimestamps[ii]]) {
          store.delete(allTimestamps[ii]);
        }
      }
    };
    allIssuesTimestamps.onerror = function getClickedTimestampError(e) {
      console.log('error: ', e);
    };

    tx.oncomplete = function c() {
      db.close();
    };
  };
};

var issuesUpdateTimer = function issuesUpdateTimer(_ref20) {
  var dispatch = _ref20.dispatch;

  /* eslint-disable */
  setInterval(function timer() {
    dispatch('getRepoIssues');
  }, 10 * 60 * 1000);

  setInterval(function issuesClickedTimestampTimer() {
    dispatch('cleanupIssuesClickedTimestamp');
  }, 60 * 60 * 1000 + 700);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setOrgs: setOrgs,
  setGithubToken: setGithubToken,
  addIssue: addIssue,
  addRecent5Issues: addRecent5Issues,
  addRecent10Issues: addRecent10Issues,
  getIssues: getIssues,
  getRepos: getRepos,
  updateIssueForCheckboxToggle: updateIssueForCheckboxToggle,
  updateAllIssuesForCheckboxToggle: updateAllIssuesForCheckboxToggle,
  resetCheckboxSelectedIssues: resetCheckboxSelectedIssues,
  setFilterText: setFilterText,
  setFilterOrg: setFilterOrg,
  setFilterTime: setFilterTime,
  setFilterType: setFilterType,
  getRepoIssues: getRepoIssues,
  issuesUpdateTimer: issuesUpdateTimer
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MyVuetable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FieldDefs__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DetailRow__ = __webpack_require__(326);
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('my-detail-row', __WEBPACK_IMPORTED_MODULE_3__components_DetailRow__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    MyVuetable: __WEBPACK_IMPORTED_MODULE_1__components_MyVuetable__["a" /* default */]
  },
  data: function data() {
    return {
      fields: __WEBPACK_IMPORTED_MODULE_2__components_FieldDefs__["a" /* default */],
      sortOrder: [{
        field: 'email',
        sortField: 'salary',
        direction: 'asc'
      }],
      moreParams: {}
    };
  }
});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyVuetable_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_256b89f6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyVuetable_vue__ = __webpack_require__(325);
function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyVuetable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_256b89f6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyVuetable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePaginationInfo__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_events__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__voerro_vue_tagsinput__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FieldDefs__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GithubToken__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FilterBar__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FilterTime__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FilterOrg__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FilterType__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__VuetablePaginationBootstrap__ = __webpack_require__(322);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('tags-input', __WEBPACK_IMPORTED_MODULE_7__voerro_vue_tagsinput__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_events___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('github-token', __WEBPACK_IMPORTED_MODULE_9__GithubToken__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('filter-bar', __WEBPACK_IMPORTED_MODULE_10__FilterBar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('filter-time', __WEBPACK_IMPORTED_MODULE_11__FilterTime__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('filter-type', __WEBPACK_IMPORTED_MODULE_13__FilterType__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('filter-org', __WEBPACK_IMPORTED_MODULE_12__FilterOrg__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-vuetable',
  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable__["a" /* default */],
    VuetablePaginationInfo: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePaginationInfo__["a" /* default */],
    VuetablePaginationBootstrap: __WEBPACK_IMPORTED_MODULE_14__VuetablePaginationBootstrap__["a" /* default */]
  },
  created: function created() {
    this.$store.dispatch('issuesUpdateTimer');
    var query = this.$route.query;

    // set filtering values when type url, share url, reload page
    if (query) {
      if (query.org) {
        var orgs = this.$store.getters.getOrgs;
        if (!orgs) {
          this.$store.dispatch('setOrgs', query.org);
        } else if (!orgs.split(',').includes(query.org)) {
          orgs = orgs + ',' + query.org;
          this.$store.dispatch('setOrgs', orgs);
        }
        this.$store.dispatch('setFilterOrg', query.org);
      } else {
        this.$store.dispatch('setFilterOrg', '');
      }
      if (query.time) {
        this.$store.dispatch('setFilterTime', query.time);
      } else {
        this.$store.dispatch('setFilterTime', '');
      }
      if (query.type) {
        this.$store.dispatch('setFilterType', query.type);
      } else {
        this.$store.dispatch('setFilterType', '');
      }
    }
  },

  props: {
    /*
    apiUrl: {
      type: String,
      required: true,
    },
    */
  },
  data: function data() {
    return {
      // fields: FieldDefs,
      repos: [],
      fields: __WEBPACK_IMPORTED_MODULE_8__FieldDefs__["a" /* default */]
    };
  },

  watch: {
    /* eslint-disable */
    $route: function $route(to, from) {
      var query = to.query;

      // handle route change using browser's back/front arrow button
      if (query) {
        if (query.org) {
          var orgs = this.$store.getters.getOrgs;
          if (!orgs) {
            this.$store.dispatch('setOrgs', query.org);
          } else if (!orgs.split(',').includes(query.org)) {
            orgs = orgs + ',' + query.org;
            this.$store.dispatch('setOrgs', orgs);
          }
          this.$store.dispatch('setFilterOrg', query.org);
        } else {
          this.$store.dispatch('setFilterOrg', '');
        }
        if (query.time) {
          this.$store.dispatch('setFilterTime', query.time);
        } else {
          this.$store.dispatch('setFilterTime', '');
        }
      }
    }
  },
  computed: {
    getIssues: function getIssues() {
      return this.$store.getters.getIssues;
    },

    orgs: {
      get: function get() {
        return this.$store.getters.getOrgs;
      },
      set: function set(value) {
        this.$store.dispatch('setOrgs', value.join(','));
      }
    },
    getCheckboxSelectedIssues: {
      get: function get() {
        console.log('Object.keys(this.$store.getters.getCheckboxSelectedIssues).length', this.$store.getters.getCheckboxSelectedIssues.length);
        return this.$store.getters.getCheckboxSelectedIssues;
      }
    }
  },
  mounted: function mounted() {
    // this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
    // this.$events.$on('filter-reset', e => this.onFilterReset(e));
  },

  methods: {
    onRowClass: function onRowClass(dataItem /* index */) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var choiceRowClass, className;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                choiceRowClass = function choiceRowClass(htmlUrl, updatedAt) {
                  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                    var idb = global.indexedDB || global.mozIndexedDB || global.webkitIndexedDB || global.msIndexedDB;

                    var open = idb.open('issues-clicked-timestamp', 2);
                    var db = '';
                    open.onupgradeneeded = function a() {
                      db = open.result;
                      db.createObjectStore('issue', { autoIncrement: true });
                    };
                    open.onsuccess = function openSuccess() {
                      db = open.result;

                      var tx = db.transaction('issue', 'readwrite');
                      var store = tx.objectStore('issue');
                      var getClickedTimestamp = store.get(htmlUrl);

                      getClickedTimestamp.onsuccess = function getClickedTimestampSuccess() {
                        var clickedTimestamp = getClickedTimestamp.result;
                        var elHref = document.querySelector('a[href="' + htmlUrl + '"]');

                        if (clickedTimestamp) {
                          if (elHref) {
                            if (clickedTimestamp < updatedAt) {
                              resolve('updated-later'); // add 'updated-later class'
                              elHref.classList.add('updated-later');
                            } else {
                              elHref.classList.remove('updated-later');
                            }
                          }
                        } else {
                          store.put(updatedAt, htmlUrl);
                          // document.querySelector(`a[href="${htmlUrl}"]`).classList.remove('updated-later');
                        }
                        resolve(); // no class should be added
                      };
                      getClickedTimestamp.onerror = function getClickedTimestampError(e) {
                        console.log('error: ', e);
                      };

                      tx.oncomplete = function c() {
                        db.close();
                      };
                    };
                  });
                };
                // const htmlUrl = dataItem.htmlUrl;
                // const updatedAt = dataItem.updatedAt;

                className = choiceRowClass(dataItem.htmlUrl, dataItem.updatedAt);
                // adding the class into title anchor
                /*
                if (className) {
                  document.querySelector(`a[href="${htmlUrl}"]`).classList.add(className);
                }
                */

                return _context.abrupt('return', '');

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleClickOnTitle: function handleClickOnTitle(params) {
      var htmlUrl = params.rowData.htmlUrl;
      var updatedAt = params.rowData.updatedAt;
      document.querySelector('a[href="' + htmlUrl + '"]').classList.remove('updated-later');

      var idb = global.indexedDB || global.mozIndexedDB || global.webkitIndexedDB || global.msIndexedDB;

      var open = idb.open('issues-clicked-timestamp', 2);
      var db = '';
      open.onupgradeneeded = function a() {
        db = open.result;
        db.createObjectStore('issue', { autoIncrement: true });
      };

      open.onsuccess = function b() {
        db = open.result;
        var tx = db.transaction('issue', 'readwrite');
        var store = tx.objectStore('issue');

        store.put(updatedAt, htmlUrl);

        tx.oncomplete = function c() {
          db.close();
        };
      };
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onAction: function onAction() /* action, data, index */{
      // console.log(`slot) action: ${action} ${data.name} ${index}`);
    },
    onCellClicked: function onCellClicked(data /* field, event */) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    onToggleCheckbox: function onToggleCheckbox(isSelected, data) {
      // this.$store.dispatch('setCheckboxSelectedIssues', this.$refs.vuetable.selectedTo);
      this.$store.dispatch('updateIssueForCheckboxToggle', { isSelected: isSelected, htmlUrl: data.htmlUrl, title: data.title, updatedAt: data.updatedAt });
      console.log('Object.keys(this.$store.getters.getCheckboxSelectedIssues).length: ', this.$store.getters.getCheckboxSelectedIssues.length);
    },
    markTheIssuesAsRead: function markTheIssuesAsRead() {
      var checkboxSelectedIssues = this.getCheckboxSelectedIssues;
      var len = checkboxSelectedIssues.length;
      for (var i = 0; i < len; i += 1) {
        this.handleClickOnTitle({ rowData: checkboxSelectedIssues[i] });
        var index = this.$refs.vuetable.selectedTo.indexOf(checkboxSelectedIssues[i].title);
        if (index > -1) {
          this.$refs.vuetable.selectedTo.splice(index, 1);
        }
      }
      this.$store.dispatch('resetCheckboxSelectedIssues'); // reset checkbox selected Items
    },
    onToggleCheckboxAll: function onToggleCheckboxAll(isSelected) {
      this.$store.dispatch('updateAllIssuesForCheckboxToggle', { isSelected: isSelected, all: true });
    },
    onFilterSet: function onFilterSet(filterText) {
      var _this2 = this;

      this.appendParams.filter = filterText;
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].nextTick(function () {
        return _this2.$refs.vuetable.refresh();
      });
    },
    onFilterReset: function onFilterReset() {
      var _this3 = this;

      delete this.appendParams.filter;
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    renderPagination: function renderPagination(h) {
      return h('div', { class: { 'vuetable-pagination': true } }, [h('vuetable-pagination-info', { ref: 'paginationInfo', props: { css: this.css.paginationInfo } }), h('vuetable-pagination-bootstrap', {
        ref: 'pagination',
        class: { 'pull-right': true },
        props: {},
        on: {
          'vuetable-pagination:change-page': this.onChangePage
        }
      })]);
    },
    getLabelStyle: function getLabelStyle(label) {
      var hexToLuma = function hexToLuma(colour) {
        var hex = colour.replace(/#/, '');
        var r = 255 - parseInt(hex.substr(0, 2), 16);
        var g = 255 - parseInt(hex.substr(2, 2), 16);
        var b = 255 - parseInt(hex.substr(4, 2), 16);
        /*
         var r = (hex & 0xff0000) >> 16;
         var g = (hex & 0x00ff00) >> 8;
         var b = hex & 0x0000ff;
         */

        return [r, g, b];
      };
      var bg = label.color;
      var fontColor = hexToLuma(bg);
      return { 'background-color': '#' + bg, 'color': 'rgb(' + fontColor[0] + ', ' + fontColor[1] + ', ' + fontColor[2] + ')' };
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    fields: {
      type: Array,
      required: true
    },
    loadOnStart: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: ''
    },
    httpMethod: {
      type: String,
      default: 'get',
      validator: function validator(value) {
        return ['get', 'post'].indexOf(value) > -1;
      }
    },
    reactiveApiUrl: {
      type: Boolean,
      default: true
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    data: {
      type: [Array, Object],
      default: null
    },
    dataTotal: {
      type: Number,
      default: 0
    },
    dataManager: {
      type: Function,
      default: null
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    paginationPath: {
      type: [String],
      default: 'links.pagination'
    },
    queryParams: {
      type: [Object, Function],
      default: function _default() {
        return {
          sort: 'sort',
          page: 'page',
          perPage: 'per_page'
        };
      }
    },
    appendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpFetch: {
      type: Function,
      default: null
    },
    perPage: {
      type: Number,
      default: 10
    },
    initialPage: {
      type: Number,
      default: 1
    },
    sortOrder: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiSort: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    tableHeight: {
      type: String,
      default: null
    },

    multiSortKey: {
      type: String,
      default: 'alt'
    },

    rowClassCallback: {
      type: [String, Function],
      default: ''
    },
    rowClass: {
      type: [String, Function],
      default: ''
    },
    detailRowComponent: {
      type: String,
      default: ''
    },
    detailRowTransition: {
      type: String,
      default: ''
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    css: {
      type: Object,
      default: function _default() {
        return {
          tableClass: 'ui blue selectable celled stackable attached table',
          loadingClass: 'loading',
          ascendingIcon: 'blue chevron up icon',
          descendingIcon: 'blue chevron down icon',
          ascendingClass: 'sorted-asc',
          descendingClass: 'sorted-desc',
          sortableIcon: '',
          detailRowClass: 'vuetable-detail-row',
          handleIcon: 'grey sidebar icon',
          tableBodyClass: 'vuetable-semantic-no-top vuetable-fixed-layout',
          tableHeaderClass: 'vuetable-fixed-layout'
        };
      }
    },
    minRows: {
      type: Number,
      default: 0
    },
    silent: {
      type: Boolean,
      default: false
    },
    noDataTemplate: {
      type: String,
      default: function _default() {
        return 'No Data Available';
      }
    },
    showSortIcons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable:',
      tableFields: [],
      tableData: null,
      tablePagination: null,
      currentPage: this.initialPage,
      selectedTo: [],
      visibleDetailRows: [],
      lastScrollPosition: 0,
      scrollBarWidth: '17px',
      scrollVisible: false
    };
  },
  mounted: function mounted() {
    this.normalizeFields();
    this.normalizeSortOrder();
    if (this.isFixedHeader) {
      this.scrollBarWidth = this.getScrollBarWidth() + 'px';
    }
    this.$nextTick(function () {
      this.fireEvent('initialized', this.tableFields);
    });

    if (this.loadOnStart) {
      this.loadData();
    }
    if (this.isFixedHeader) {
      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        elem.addEventListener('scroll', this.handleScroll);
      }
    }
  },
  destroyed: function destroyed() {
    var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
    if (elem != null) {
      elem.removeEventListener('scroll', this.handleScroll);
    }
  },

  computed: {
    version: function version() {
      return VERSION;
    },
    useDetailRow: function useDetailRow() {
      if (this.tableData && this.tableData[0] && this.detailRowComponent !== '' && typeof this.tableData[0][this.trackBy] === 'undefined') {
        this.warn('You need to define unique row identifier in order for detail-row feature to work. Use `track-by` prop to define one!');
        return false;
      }

      return this.detailRowComponent !== '';
    },
    countVisibleFields: function countVisibleFields() {
      return this.tableFields.filter(function (field) {
        return field.visible;
      }).length;
    },
    countTableData: function countTableData() {
      if (this.tableData === null) {
        return 0;
      }
      return this.tableData.length;
    },
    displayEmptyDataRow: function displayEmptyDataRow() {
      return this.countTableData === 0 && this.noDataTemplate.length > 0;
    },
    lessThanMinRows: function lessThanMinRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return true;
      }
      return this.tableData.length < this.minRows;
    },
    blankRows: function blankRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return this.minRows;
      }
      if (this.tableData.length >= this.minRows) {
        return 0;
      }

      return this.minRows - this.tableData.length;
    },
    isApiMode: function isApiMode() {
      return this.apiMode;
    },
    isDataMode: function isDataMode() {
      return !this.apiMode;
    },
    isFixedHeader: function isFixedHeader() {
      return this.tableHeight != null;
    }
  },
  methods: {
    getScrollBarWidth: function getScrollBarWidth() {
      var outer = document.createElement('div');
      var inner = document.createElement('div');

      outer.style.visibility = 'hidden';
      outer.style.width = '100px';

      inner.style.width = '100%';

      outer.appendChild(inner);
      document.body.appendChild(outer);

      var widthWithoutScrollbar = outer.offsetWidth;

      outer.style.overflow = 'scroll';

      var widthWithScrollbar = inner.offsetWidth;

      document.body.removeChild(outer);

      return widthWithoutScrollbar - widthWithScrollbar;
    },
    handleScroll: function handleScroll(e) {
      var horizontal = e.currentTarget.scrollLeft;
      if (horizontal != this.lastScrollPosition) {
        var header = this.$el.getElementsByClassName('vuetable-head-wrapper')[0];
        if (header != null) {
          header.scrollLeft = horizontal;
        }
        this.lastScrollPosition = horizontal;
      }
    },
    normalizeFields: function normalizeFields() {
      if (typeof this.fields === 'undefined') {
        this.warn('You need to provide "fields" prop.');
        return;
      }

      this.tableFields = [];
      var self = this;
      var obj = void 0;
      this.fields.forEach(function (field, i) {
        if (typeof field === 'string') {
          obj = {
            name: field,
            title: self.setTitle(field),
            titleClass: '',
            dataClass: '',
            callback: null,
            visible: true
          };
        } else {
          obj = {
            name: field.name,
            width: field.width,
            title: field.title === undefined ? self.setTitle(field.name) : field.title,
            sortField: field.sortField,
            titleClass: field.titleClass === undefined ? '' : field.titleClass,
            dataClass: field.dataClass === undefined ? '' : field.dataClass,
            callback: field.callback === undefined ? '' : field.callback,
            visible: field.visible === undefined ? true : field.visible
          };
        }
        self.tableFields.push(obj);
      });
    },
    setData: function setData(data) {
      if (data === null || typeof data === 'undefined') return;

      this.fireEvent('loading');

      if (Array.isArray(data)) {
        this.tableData = data;
        this.fireEvent('loaded');
        return;
      }

      this.tableData = this.getObjectValue(data, this.dataPath, null);
      this.tablePagination = this.getObjectValue(data, this.paginationPath, null);

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    setTitle: function setTitle(str) {
      if (this.isSpecialField(str)) {
        return '';
      }

      return this.titleCase(str);
    },
    getTitle: function getTitle(field) {
      if (typeof field.title === 'function') return field.title();

      return typeof field.title === 'undefined' ? field.name.replace('.', ' ') : field.title;
    },
    renderTitle: function renderTitle(field) {
      var title = this.getTitle(field);

      if (title.length > 0 && this.isInCurrentSortGroup(field) || this.hasSortableIcon(field)) {
        var style = 'opacity:' + this.sortIconOpacity(field) + ';position:relative;float:right';
        var iconTag = this.showSortIcons ? this.renderIconTag(['sort-icon', this.sortIcon(field)], 'style="' + style + '"') : '';
        return title + ' ' + iconTag;
      }

      return title;
    },
    renderSequence: function renderSequence(index) {
      return this.tablePagination ? this.tablePagination.from + index : index;
    },
    renderNormalField: function renderNormalField(field, item) {
      return this.hasCallback(field) ? this.callCallback(field, item) : this.getObjectValue(item, field.name, '');
    },
    isSpecialField: function isSpecialField(fieldName) {
      return fieldName.slice(0, 2) === '__';
    },
    titleCase: function titleCase(str) {
      return str.replace(/\w+/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    camelCase: function camelCase(str) {
      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

      var self = this;
      return str.split(delimiter).map(function (item) {
        return self.titleCase(item);
      }).join('');
    },
    notIn: function notIn(str, arr) {
      return arr.indexOf(str) === -1;
    },
    loadData: function loadData() {
      var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.loadSuccess;
      var failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.loadFailed;

      if (this.isDataMode) {
        this.callDataManager();
        return;
      }

      this.fireEvent('loading');

      this.httpOptions['params'] = this.getAppendParams(this.getAllQueryParams());

      return this.fetch(this.apiUrl, this.httpOptions).then(success, failed).catch(function () {
        return failed();
      });
    },
    fetch: function fetch(apiUrl, httpOptions) {
      return this.httpFetch ? this.httpFetch(apiUrl, httpOptions) : __WEBPACK_IMPORTED_MODULE_1_axios___default.a[this.httpMethod](apiUrl, httpOptions);
    },
    loadSuccess: function loadSuccess(response) {
      this.fireEvent('load-success', response);

      var body = this.transform(response.data);

      this.tableData = this.getObjectValue(body, this.dataPath, null);
      this.tablePagination = this.getObjectValue(body, this.paginationPath, null);

      if (this.tablePagination === null) {
        this.warn('vuetable: pagination-path "' + this.paginationPath + '" not found. ' + 'It looks like the data returned from the sever does not have pagination information ' + "or you may have set it incorrectly.\n" + 'You can explicitly suppress this warning by setting pagination-path="".');
      }

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    fixHeader: function fixHeader() {
      if (!this.isFixedHeader) {
        return;
      }

      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        if (elem.scrollHeight > elem.clientHeight) {
          this.scrollVisible = true;
        } else {
          this.scrollVisible = false;
        }
      }
    },
    loadFailed: function loadFailed(response) {
      console.error('load-error', response);
      this.fireEvent('load-error', response);
      this.fireEvent('loaded');
    },
    transform: function transform(data) {
      var func = 'transform';

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, data);
      }

      return data;
    },
    parentFunctionExists: function parentFunctionExists(func) {
      return func !== '' && typeof this.$parent[func] === 'function';
    },
    callParentFunction: function callParentFunction(func, args) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, args);
      }

      return defaultValue;
    },
    fireEvent: function fireEvent(eventName, args) {
      this.$emit(this.eventPrefix + eventName, args);
    },
    warn: function warn(msg) {
      if (!this.silent) {
        console.warn(msg);
      }
    },
    getAllQueryParams: function getAllQueryParams() {
      var params = {};

      if (typeof this.queryParams === 'function') {
        params = this.queryParams(this.sortOrder, this.currentPage, this.perPage);
        return (typeof params === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(params)) !== 'object' ? {} : params;
      }

      params[this.queryParams.sort] = this.getSortParam();
      params[this.queryParams.page] = this.currentPage;
      params[this.queryParams.perPage] = this.perPage;

      return params;
    },
    getSortParam: function getSortParam() {
      if (!this.sortOrder || this.sortOrder.field == '') {
        return '';
      }

      if (typeof this.$parent['getSortParam'] === 'function') {
        return this.$parent['getSortParam'].call(this.$parent, this.sortOrder);
      }

      return this.getDefaultSortParam();
    },
    getDefaultSortParam: function getDefaultSortParam() {
      var result = '';

      for (var i = 0; i < this.sortOrder.length; i++) {
        var fieldName = typeof this.sortOrder[i].sortField === 'undefined' ? this.sortOrder[i].field : this.sortOrder[i].sortField;

        result += fieldName + '|' + this.sortOrder[i].direction + (i + 1 < this.sortOrder.length ? ',' : '');
      }
      return result;
    },
    getAppendParams: function getAppendParams(params) {
      for (var x in this.appendParams) {
        params[x] = this.appendParams[x];
      }

      return params;
    },
    extractName: function extractName(string) {
      return string.split(':')[0].trim();
    },
    extractArgs: function extractArgs(string) {
      return string.split(':')[1];
    },
    isSortable: function isSortable(field) {
      return !(typeof field.sortField === 'undefined');
    },
    isInCurrentSortGroup: function isInCurrentSortGroup(field) {
      return this.currentSortOrderPosition(field) !== false;
    },
    hasSortableIcon: function hasSortableIcon(field) {
      return this.isSortable(field) && this.css.sortableIcon != '';
    },
    currentSortOrderPosition: function currentSortOrderPosition(field) {
      if (!this.isSortable(field)) {
        return false;
      }

      for (var i = 0; i < this.sortOrder.length; i++) {
        if (this.fieldIsInSortOrderPosition(field, i)) {
          return i;
        }
      }

      return false;
    },
    fieldIsInSortOrderPosition: function fieldIsInSortOrderPosition(field, i) {
      return this.sortOrder[i].field === field.name && this.sortOrder[i].sortField === field.sortField;
    },
    orderBy: function orderBy(field, event) {
      if (!this.isSortable(field)) return;

      var key = this.multiSortKey.toLowerCase() + 'Key';

      if (this.multiSort && event[key]) {
        this.multiColumnSort(field);
      } else {
        this.singleColumnSort(field);
      }

      this.currentPage = 1;
      if (this.apiMode || this.dataManager) {
        this.loadData();
      }
    },
    multiColumnSort: function multiColumnSort(field) {
      var i = this.currentSortOrderPosition(field);

      if (i === false) {
        this.sortOrder.push({
          field: field.name,
          sortField: field.sortField,
          direction: 'asc'
        });
      } else {
        if (this.sortOrder[i].direction === 'asc') {
          this.sortOrder[i].direction = 'desc';
        } else {
          this.sortOrder.splice(i, 1);
        }
      }
    },
    singleColumnSort: function singleColumnSort(field) {
      if (this.sortOrder.length === 0) {
        this.clearSortOrder();
      }

      this.sortOrder.splice(1);

      if (this.fieldIsInSortOrderPosition(field, 0)) {
        this.sortOrder[0].direction = this.sortOrder[0].direction === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder[0].direction = 'asc';
      }
      this.sortOrder[0].field = field.name;
      this.sortOrder[0].sortField = field.sortField;
    },
    clearSortOrder: function clearSortOrder() {
      this.sortOrder.push({
        field: '',
        sortField: '',
        direction: 'asc'
      });
    },
    sortClass: function sortClass(field) {
      var cls = '';
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingClass : this.css.descendingClass;
      }

      return cls;
    },
    sortIcon: function sortIcon(field) {
      var cls = this.css.sortableIcon;
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingIcon : this.css.descendingIcon;
      }

      return cls;
    },
    sortIconOpacity: function sortIconOpacity(field) {
      var max = 1.0,
          min = 0.3,
          step = 0.3;

      var count = this.sortOrder.length;
      var current = this.currentSortOrderPosition(field);

      if (max - count * step < min) {
        step = (max - min) / (count - 1);
      }

      var opacity = max - current * step;

      return opacity;
    },
    hasCallback: function hasCallback(item) {
      return item.callback ? true : false;
    },
    callCallback: function callCallback(field, item) {
      if (!this.hasCallback(field)) return;

      if (typeof field.callback == 'function') {
        return field.callback(this.getObjectValue(item, field.name));
      }

      var args = field.callback.split('|');
      var func = args.shift();

      if (typeof this.$parent[func] === 'function') {
        var value = this.getObjectValue(item, field.name);

        return args.length > 0 ? this.$parent[func].apply(this.$parent, [value].concat(args)) : this.$parent[func].call(this.$parent, value);
      }

      return null;
    },
    getObjectValue: function getObjectValue(object, path, defaultValue) {
      defaultValue = typeof defaultValue === 'undefined' ? null : defaultValue;

      var obj = object;
      if (path.trim() != '') {
        var keys = path.split('.');
        keys.forEach(function (key) {
          if (obj !== null && typeof obj[key] !== 'undefined' && obj[key] !== null) {
            obj = obj[key];
          } else {
            obj = defaultValue;
            return;
          }
        });
      }
      return obj;
    },
    toggleCheckbox: function toggleCheckbox(dataItem, fieldName, event) {
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (dataItem[idColumn] === undefined) {
        this.warn('__checkbox field: The "' + this.trackBy + '" field does not exist! Make sure the field you specify in "track-by" prop does exist.');
        return;
      }

      var key = dataItem[idColumn];
      if (isChecked) {
        this.selectId(key);
      } else {
        this.unselectId(key);
      }
      this.$emit('vuetable:checkbox-toggled', isChecked, dataItem);
    },
    selectId: function selectId(key) {
      if (!this.isSelectedRow(key)) {
        this.selectedTo.push(key);
      }
    },
    unselectId: function unselectId(key) {
      this.selectedTo = this.selectedTo.filter(function (item) {
        return item !== key;
      });
    },
    isSelectedRow: function isSelectedRow(key) {
      return this.selectedTo.indexOf(key) >= 0;
    },
    rowSelected: function rowSelected(dataItem, fieldName) {
      var idColumn = this.trackBy;
      var key = dataItem[idColumn];

      return this.isSelectedRow(key);
    },
    checkCheckboxesState: function checkCheckboxesState(fieldName) {
      if (!this.tableData) return;

      var self = this;
      var idColumn = this.trackBy;
      var selector = 'th.vuetable-th-checkbox-' + idColumn + ' input[type=checkbox]';
      var els = document.querySelectorAll(selector);

      if (els.forEach === undefined) els.forEach = function (cb) {
        [].forEach.call(els, cb);
      };

      var selected = this.tableData.filter(function (item) {
        return self.selectedTo.indexOf(item[idColumn]) >= 0;
      });

      if (selected.length <= 0) {
        els.forEach(function (el) {
          el.indeterminate = false;
        });
        return false;
      } else if (selected.length < this.perPage) {
          els.forEach(function (el) {
            el.indeterminate = true;
          });
          return true;
        } else {
            els.forEach(function (el) {
              el.indeterminate = false;
            });
            return true;
          }
    },
    toggleAllCheckboxes: function toggleAllCheckboxes(fieldName, event) {
      var self = this;
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (isChecked) {
        this.tableData.forEach(function (dataItem) {
          self.selectId(dataItem[idColumn]);
        });
      } else {
        this.tableData.forEach(function (dataItem) {
          self.unselectId(dataItem[idColumn]);
        });
      }
      this.$emit('vuetable:checkbox-toggled-all', isChecked);
    },
    gotoPreviousPage: function gotoPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadData();
      }
    },
    gotoNextPage: function gotoNextPage() {
      if (this.currentPage < this.tablePagination.last_page) {
        this.currentPage++;
        this.loadData();
      }
    },
    gotoPage: function gotoPage(page) {
      if (page != this.currentPage && page > 0 && page <= this.tablePagination.last_page) {
        this.currentPage = page;
        this.loadData();
      }
    },
    isVisibleDetailRow: function isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetailRow: function showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow: function hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow: function toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    showField: function showField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = true;
    },
    hideField: function hideField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = false;
    },
    toggleField: function toggleField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = !this.tableFields[index].visible;
    },
    renderIconTag: function renderIconTag(classes) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return typeof this.css.renderIcon === 'undefined' ? '<i class="' + classes.join(' ') + '" ' + options + '></i>' : this.css.renderIcon(classes, options);
    },
    makePagination: function makePagination() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var currentPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var pagination = {};
      total = total === null ? this.dataTotal : total;
      perPage = perPage === null ? this.perPage : perPage;
      currentPage = currentPage === null ? this.currentPage : currentPage;

      return {
        'total': total,
        'per_page': perPage,
        'current_page': currentPage,
        'last_page': Math.ceil(total / perPage) || 0,
        'next_page_url': '',
        'prev_page_url': '',
        'from': (currentPage - 1) * perPage + 1,
        'to': Math.min(currentPage * perPage, total)
      };
    },
    normalizeSortOrder: function normalizeSortOrder() {
      this.sortOrder.forEach(function (item) {
        item.sortField = item.sortField || item.field;
      });
    },
    callDataManager: function callDataManager() {
      if (this.dataManager === null && this.data === null) return;

      if (Array.isArray(this.data)) {
        return this.setData(this.data);
      }

      this.normalizeSortOrder();

      return this.setData(this.dataManager ? this.dataManager(this.sortOrder, this.makePagination()) : this.data);
    },
    onRowClass: function onRowClass(dataItem, index) {
      if (this.rowClassCallback !== '') {
        this.warn('"row-class-callback" prop is deprecated, please use "row-class" prop instead.');
        return;
      }

      if (typeof this.rowClass === 'function') {
        return this.rowClass(dataItem, index);
      }

      return this.rowClass;
    },
    onRowChanged: function onRowChanged(dataItem) {
      this.fireEvent('row-changed', dataItem);
      return true;
    },
    onRowClicked: function onRowClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-clicked', dataItem, event);
      return true;
    },
    onRowDoubleClicked: function onRowDoubleClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-dblclicked', dataItem, event);
    },
    onDetailRowClick: function onDetailRowClick(dataItem, event) {
      this.$emit(this.eventPrefix + 'detail-row-clicked', dataItem, event);
    },
    onCellClicked: function onCellClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-clicked', dataItem, field, event);
    },
    onCellDoubleClicked: function onCellDoubleClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-dblclicked', dataItem, field, event);
    },
    onCellRightClicked: function onCellRightClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-rightclicked', dataItem, field, event);
    },
    changePage: function changePage(page) {
      if (page === 'prev') {
        this.gotoPreviousPage();
      } else if (page === 'next') {
        this.gotoNextPage();
      } else {
        this.gotoPage(page);
      }
    },
    reload: function reload() {
      return this.loadData();
    },
    refresh: function refresh() {
      this.currentPage = 1;
      return this.loadData();
    },
    resetData: function resetData() {
      this.tableData = null;
      this.tablePagination = null;
      this.fireEvent('data-reset');
    }
  },
  watch: {
    'multiSort': function multiSort(newVal, oldVal) {
      if (newVal === false && this.sortOrder.length > 1) {
        this.sortOrder.splice(1);
        this.loadData();
      }
    },
    'apiUrl': function apiUrl(newVal, oldVal) {
      if (this.reactiveApiUrl && newVal !== oldVal) this.refresh();
    },
    'data': function data(newVal, oldVal) {
      this.setData(newVal);
    },
    'tableHeight': function tableHeight(newVal, oldVal) {
      this.fixHeader();
    }
  }
});

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationInfoMixin_vue__ = __webpack_require__(297);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationInfoMixin_vue__["a" /* default */]]
});

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    css: {
      type: Object,
      default: function _default() {
        return {
          infoClass: 'left floated left aligned six wide column'
        };
      }
    },
    infoTemplate: {
      type: String,
      default: function _default() {
        return "Displaying {from} to {to} of {total} items";
      }
    },
    noDataTemplate: {
      type: String,
      default: function _default() {
        return 'No relevant data';
      }
    }
  },
  data: function data() {
    return {
      tablePagination: null
    };
  },
  computed: {
    paginationInfo: function paginationInfo() {
      if (this.tablePagination == null || this.tablePagination.total == 0) {
        return this.noDataTemplate;
      }

      return this.infoTemplate.replace('{from}', this.tablePagination.from || 0).replace('{to}', this.tablePagination.to || 0).replace('{total}', this.tablePagination.total || 0);
    }
  },
  methods: {
    setPaginationData: function setPaginationData(tablePagination) {
      this.tablePagination = tablePagination;
    },
    resetData: function resetData() {
      this.tablePagination = null;
    }
  }
});

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        elementId: String,

        existingTags: {
            type: Object,
            default: function _default() {
                return {};
            }
        },

        value: {
            type: [Array, String],
            default: function _default() {
                return [];
            }
        },

        typeahead: {
            type: Boolean,
            default: false
        },

        typeaheadStyle: {
            type: String,
            default: 'badges'
        },

        typeaheadActivationThreshold: {
            type: Number,
            default: 1
        },

        typeaheadMaxResults: {
            type: Number,
            default: 0
        },

        placeholder: {
            type: String,
            default: 'Add a tag'
        },

        limit: {
            type: Number,
            default: 0
        },

        onlyExistingTags: {
            type: Boolean,
            default: false
        },

        deleteOnBackspace: {
            type: Boolean,
            default: true
        },

        allowDuplicates: {
            type: Boolean,
            default: false
        },

        validate: {
            type: Function,
            default: function _default() {
                return true;
            }
        },

        addTagsOnComma: {
            type: Boolean,
            default: false
        },

        wrapperClass: {
            type: String,
            default: 'tags-input-wrapper-default'
        }
    },

    data: function data() {
        return {
            badgeId: 0,
            tagBadges: [],
            tags: [],

            input: '',
            oldInput: '',
            hiddenInput: '',

            searchResults: [],
            searchSelection: 0
        };
    },
    created: function created() {
        this.tagsFromValue();

        // Emit an event
        this.$emit('initialized');
    },


    watch: {
        tags: function tags() {
            // Updating the hidden input
            this.hiddenInput = this.tags.join(',');

            // Update the bound v-model value
            this.$emit('input', this.tags);
        },
        value: function value() {
            this.tagsFromValue();
        }
    },

    methods: {
        escapeRegExp: function escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        },
        tagFromInput: function tagFromInput() {
            // If we're choosing a tag from the search results
            if (this.searchResults.length && this.searchSelection >= 0) {
                this.tagFromSearch(this.searchResults[this.searchSelection]);

                this.input = '';
            } else {
                // If we're adding an unexisting tag
                var text = this.input.trim();

                // If the new tag is not an empty string and passes validation
                if (!this.onlyExistingTags && text.length && this.validate(text)) {
                    this.input = '';

                    // Determine the tag's slug and text depending on if the tag exists
                    // on the site already or not
                    var slug = this.makeSlug(text);
                    var existingTag = this.existingTags[slug];

                    slug = existingTag ? slug : text;
                    text = existingTag ? existingTag : text;

                    this.addTag(slug, text);
                }
            }
        },
        tagFromSearchOnClick: function tagFromSearchOnClick(tag) {
            this.tagFromSearch(tag);

            this.$refs['taginput'].blur();
        },
        tagFromSearch: function tagFromSearch(tag) {
            this.searchResults = [];
            this.input = '';
            this.oldInput = '';

            this.addTag(tag.slug, tag.text);
        },
        makeSlug: function makeSlug(value) {
            return value.toLowerCase().replace(/\s/g, '-');
        },
        addTag: function addTag(slug, text) {
            // Check if the limit has been reached
            if (this.limit > 0 && this.tags.length >= this.limit) {
                return false;
            }

            // Attach the tag if it hasn't been attached yet
            if (!this.tagSelected(slug)) {
                this.tagBadges.push(text.replace(/\s/g, '&nbsp;'));
                this.tags.push(slug);
            }

            // Emit events
            this.$emit('tag-added', slug);
            this.$emit('tags-updated');
        },
        removeLastTag: function removeLastTag() {
            if (!this.input.length && this.deleteOnBackspace) {
                this.removeTag(this.tags.length - 1);
            }
        },
        removeTag: function removeTag(index) {
            var slug = this.tags[index];

            this.tags.splice(index, 1);
            this.tagBadges.splice(index, 1);

            // Emit events
            this.$emit('tag-removed', slug);
            this.$emit('tags-updated');
        },
        searchTag: function searchTag() {
            if (this.typeahead === true) {
                if (this.oldInput != this.input || !this.searchResults.length && this.typeaheadActivationThreshold == 0) {
                    this.searchResults = [];
                    this.searchSelection = 0;
                    var input = this.input.trim();

                    if (input.length && input.length >= this.typeaheadActivationThreshold || this.typeaheadActivationThreshold == 0) {
                        for (var slug in this.existingTags) {
                            var text = this.existingTags[slug].toLowerCase();

                            if (text.search(this.escapeRegExp(input.toLowerCase())) > -1 && !this.tagSelected(slug)) {
                                this.searchResults.push({ slug: slug, text: this.existingTags[slug] });
                            }
                        }

                        // Sort the search results alphabetically
                        this.searchResults.sort(function (a, b) {
                            if (a.text < b.text) return -1;
                            if (a.text > b.text) return 1;

                            return 0;
                        });

                        // Shorten Search results to desired length
                        if (this.typeaheadMaxResults > 0) {
                            this.searchResults = this.searchResults.slice(0, this.typeaheadMaxResults);
                        }
                    }

                    this.oldInput = this.input;
                }
            }
        },
        onFocus: function onFocus() {
            this.searchTag();
        },
        hideTypeahead: function hideTypeahead() {
            var _this = this;

            if (!this.input.length) {
                this.$nextTick(function () {
                    _this.ignoreSearchResults();
                });
            }
        },
        nextSearchResult: function nextSearchResult() {
            if (this.searchSelection + 1 <= this.searchResults.length - 1) {
                this.searchSelection++;
            }
        },
        prevSearchResult: function prevSearchResult() {
            if (this.searchSelection > 0) {
                this.searchSelection--;
            }
        },
        ignoreSearchResults: function ignoreSearchResults() {
            this.searchResults = [];
            this.searchSelection = 0;
        },


        /**
        * Clear the list of selected tags
        */
        clearTags: function clearTags() {
            this.tags.splice(0, this.tags.length);
            this.tagBadges.splice(0, this.tagBadges.length);
        },


        /**
        * Replace the currently selected tags with the tags from the value
        */
        tagsFromValue: function tagsFromValue() {
            if (this.value && this.value.length) {
                var tags = Array.isArray(this.value) ? this.value : this.value.split(',');

                if (this.tags == tags) {
                    return;
                }

                this.clearTags();

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var slug = _step.value;

                        var existingTag = this.existingTags[slug];
                        var text = existingTag ? existingTag : slug;

                        this.addTag(slug, text);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else {
                if (this.tags.length == 0) {
                    return;
                }

                this.clearTags();
            }
        },


        /**
        * Check if the tag with the provided slug is already selected
        */
        tagSelected: function tagSelected(slug) {
            var _this2 = this;

            if (this.allowDuplicates) {
                return false;
            }

            if (!slug) {
                return false;
            }

            var searchSlug = this.makeSlug(slug);
            var found = this.tags.find(function (value) {
                return searchSlug == _this2.makeSlug(value);
            });

            return !!found;
        },


        /**
         * Process all the keydown events
         */
        onKeyDown: function onKeyDown(e) {
            // Insert a new tag on comma keydown if the option is enabled
            if (e.key == ',') {
                if (this.addTagsOnComma) {
                    // The comma shouldn't actually be inserted
                    e.preventDefault();

                    // Add the inputed tag
                    this.tagFromInput();
                }
            }
        }
    }
});

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
/*
{
  name: '__sequence',
  title: '#',
  titleClass: 'center aligned',
  dataClass: 'center aligned',
},
*/
{
  name: '__checkbox',
  titleClass: 'text-center',
  dataClass: 'text-center'
}, {
  name: '__slot:index',
  title: '#'
}, {
  name: '__slot:titlelink',
  title: 'Title'
},
/*
{
  name: 'orgName',
  title: 'Organization',
  sortField: 'orgName',
  titleClass: 'center aligned',
  dataClass: 'center aligned',
},
{
  name: 'repoName',
  title: 'Repository',
  sortField: 'repoName',
  titleClass: 'center aligned',
  dataClass: 'center aligned',
},
*/
{
  name: '__slot:issueNumber',
  title: 'Issue #'
}, {
  name: 'createdAt',
  title: 'Created At',
  titleClass: 'center aligned',
  dataClass: 'center aligned'
}]);

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      githubToken: ''
    };
  },

  computed: {
    githubTokenExist: {
      get: function get() {
        return this.$store.getters.getGithubToken;
      }
    }
  },
  methods: {
    setGithubToken: function setGithubToken() {
      console.log('githubToken: ', this.githubToken);
      this.$store.dispatch('setGithubToken', this.githubToken);
    }
  }
});

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: {
    filterText: {
      get: function get() {
        return this.$store.getters.getFilterText;
      },
      set: function set(value) {
        this.$store.dispatch('setFilterText', value);
      }
    }
  }
});

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: {
    filterTime: {
      get: function get() {
        return this.$store.getters.getFilterTime;
      },
      set: function set(value) {
        this.$store.dispatch('setFilterTime', value);
      }
    }
  },
  methods: {
    handleTimeChange: function handleTimeChange(e) {
      var time = e.currentTarget.value;
      var query = {};
      if (this.$route.query) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(query, this.$route.query);
      }
      if (time) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(query, { time: time });
      } else {
        delete query.time;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).length) {
        this.$router.push({ name: 'Search', query: query });
      } else {
        this.$router.push({ name: 'MyVuetable' });
      }
    }
  }
});

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: {
    orgs: function orgs() {
      return this.$store.getters.getOrgs && this.$store.getters.getOrgs.split(',');
    },

    filterOrg: {
      get: function get() {
        return this.$store.getters.getFilterOrg;
      },
      set: function set(orgName) {
        this.$store.dispatch('setFilterOrg', orgName);
      }
    }
  },
  methods: {
    handleOrgChange: function handleOrgChange(e) {
      var org = e.currentTarget.value;
      var query = {};
      if (this.$route.query) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(query, this.$route.query);
      }
      if (org) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(query, { org: org });
      } else {
        delete query.org;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).length) {
        this.$router.push({ name: 'Search', query: query });
      } else {
        this.$router.push({ name: 'MyVuetable' });
      }
    }
  }
});

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(87);



//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getFilterType']), {
    filterType: {
      get: function get() {
        return this.getFilterType;
      },
      set: function set(type) {
        this.$store.dispatch('setFilterType', type);
      }
    }
  }),
  methods: {
    handleTypeChange: function handleTypeChange(e) {
      var type = e.currentTarget.value;
      var query = {};
      if (this.$route.query) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(query, this.$route.query);
      }
      if (type) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(query, { type: type });
      } else {
        delete query.type;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).length) {
        this.$router.push({ name: 'Search', query: query });
      } else {
        this.$router.push({ name: 'MyVuetable' });
      }
    }
  }
});

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetablePaginationMixin__ = __webpack_require__(323);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_VuetablePaginationMixin__["a" /* default */]]
});

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    css: {
      type: Object,
      default: function _default() {
        return {
          wrapperClass: 'ui right floated pagination menu',
          activeClass: 'active large',
          disabledClass: 'disabled',
          pageClass: 'item',
          linkClass: 'icon item',
          paginationClass: 'ui bottom attached segment grid',
          paginationInfoClass: 'left floated left aligned six wide column',
          dropdownClass: 'ui search dropdown',
          icons: {
            first: 'angle double left icon',
            prev: 'left chevron icon',
            next: 'right chevron icon',
            last: 'angle double right icon'
          }
        };
      }
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable-pagination:',
      tablePagination: null
    };
  },
  computed: {
    totalPage: function totalPage() {
      return this.tablePagination === null ? 0 : this.tablePagination.last_page;
    },
    isOnFirstPage: function isOnFirstPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === 1;
    },
    isOnLastPage: function isOnLastPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === this.tablePagination.last_page;
    },
    notEnoughPages: function notEnoughPages() {
      return this.totalPage < this.onEachSide * 2 + 4;
    },
    windowSize: function windowSize() {
      return this.onEachSide * 2 + 1;
    },
    windowStart: function windowStart() {
      if (!this.tablePagination || this.tablePagination.current_page <= this.onEachSide) {
        return 1;
      } else if (this.tablePagination.current_page >= this.totalPage - this.onEachSide) {
        return this.totalPage - this.onEachSide * 2;
      }

      return this.tablePagination.current_page - this.onEachSide;
    }
  },
  methods: {
    loadPage: function loadPage(page) {
      this.$emit(this.eventPrefix + 'change-page', page);
    },
    isCurrentPage: function isCurrentPage(page) {
      return page === this.tablePagination.current_page;
    },
    setPaginationData: function setPaginationData(tablePagination) {
      this.tablePagination = tablePagination;
    },
    resetData: function resetData() {
      this.tablePagination = null;
    }
  }
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onClick: function onClick() /* event */{
      // console.log('my-detail-row: on-click', event.target);
    }
  }
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction: function itemAction() /* action, data, index */{
      // console.log(`custom-actions: ${action} ${data.name} ${index}`);
    }
  }
});

/***/ })

},[233]);


// WEBPACK FOOTER //
// static/js/app.8bfa8cd46755b3d91adc.js